import React from 'react';
import PropTypes from 'prop-types';

import { FormControl as MUIFormControl } from '@material-ui/core';

export const FormControl = props => <MUIFormControl {...props} />;

FormControl.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  focused: PropTypes.bool,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  required: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  style: PropTypes.object,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};

export default FormControl;
